import { AbstractSocialService } from './AbstractSocialService';
import { Singleton } from '@denishussar/html5-game-engine';

@Singleton
export class EmptySocialService extends AbstractSocialService {
    addToFavorite(): Promise<any> {
        return Promise.reject('addToFavorite Not have this method in EmptySocialService');
    }

    getAllowNotification(): Promise<any> {
        return Promise.reject('getAllowNotification Not have this method in EmptySocialService');
    }

    showInviteOneUser(uid: number): Promise<void> {
        return Promise.reject('showInviteOneUser Not have this method in EmptySocialService');
    }

    async initApp() {
        return Promise.reject('initApp Not have this method in EmptySocialService');
    }

    async postMessage(message: string, attachments: string = '') {
        return Promise.reject('postMessage Not have this method in EmptySocialService');
    }

    async getFriends() {
        return Promise.reject('getFriends Not have this method in EmptySocialService');
    }

    async showNotification() {
        return Promise.reject('showNotification Not have this method in EmptySocialService');
    }

    async showInvite() {
        return Promise.reject('showInvite Not have this method in EmptySocialService');
    }

    async joinGroup() {
        return Promise.reject('joinGroup Not have this method in EmptySocialService');
    }

    public getToken() {
        return Promise.reject('getToken Not have this method in EmptySocialService');
    }
}